import React, { useContext } from 'react';
import { Box, Container, Link, Typography, Stack, List, ListItem, Divider } from '@mui/material';
import { useTranslation } from '../../i18n';
import { LangContext } from '../index';

export const Footer: React.FC = () => {
  const { lang } = useContext(LangContext);
  const { t } = useTranslation(lang);
  
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        bgcolor: 'black',
        color: 'white',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        position: 'relative',
        zIndex: 20,
        width: '100%',
        left: 0,
        right: 0,
        bottom: 0,
        display: 'block !important',
        visibility: 'visible !important'
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={3} alignItems="center">
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1.5, sm: 3 }} alignItems="center" flexWrap="wrap" justifyContent="center">
            <Link href="/temoignages" sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
              Témoignages
            </Link>
            <Link href="/faq" sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
              FAQ
            </Link>
            <Link href="/contact" sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
              {t('footer.contact')}
            </Link>
            <Link href="/legal" sx={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.85rem', '&:hover': { color: 'rgba(255,255,255,0.7)' } }}>
              {t('footer.legal')}
            </Link>
          </Stack>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.07)', width: '100%' }} />
          <Stack spacing={2} alignItems="center">
            <Typography variant="body2" color="rgba(255,255,255,0.7)" align="center">
              2025 TACTICAFOOT. {t('footer.rights')}
            </Typography>
          </Stack>

          <Stack spacing={2} alignItems="center">
            <Typography variant="subtitle2" color="rgba(255,255,255,0.7)" align="center">
              {t('footer.otherTools.title')}
            </Typography>
            <Link 
              href="https://www.footballcoachs.com" 
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                textDecoration: 'none',
                transition: 'color 0.2s',
                '&:hover': {
                  color: 'white'
                }
              }}
            >
              FootballCoachs.com
            </Link>
            <List sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem', textAlign: 'center' }}>
              {t('footer.otherTools.features').split(',').map((feature, index) => (
                <ListItem key={index} sx={{ justifyContent: 'center', py: 0.5 }}>
                  {feature.trim()}
                </ListItem>
              ))}
            </List>
          </Stack>

        </Stack>
      </Container>
    </Box>
  );
};
